import PropTypes from 'prop-types'

const ATTACHMENT_TYPE_POST = 'Post'
const ATTACHMENT_TYPE_EXTRACTION_LINK = 'extractionLink'
const ATTACHMENT_TYPE_AAM_EXTRACTION_LINK = 'aamExtractionLink'
const ATTACHMENT_TYPE_IEP_LINK = 'iepLink'
const ATTACHMENT_TYPE_IPP_LINK = 'ippLink'
const ATTACHMENT_TYPE_SOURCE = 'source'
const ATTACHMENT_TYPE_FOLLOW_UP = 'followUp'
const ATTACHMENT_TYPE_504_LINK = '504Link'
const ATTACHMENT_TYPE_USER_INTERACTION = 'userInteraction'

const ATTACHMENT_TYPES = [
  ATTACHMENT_TYPE_POST,
  ATTACHMENT_TYPE_EXTRACTION_LINK,
  ATTACHMENT_TYPE_AAM_EXTRACTION_LINK,
  ATTACHMENT_TYPE_IEP_LINK,
  ATTACHMENT_TYPE_IPP_LINK,
  ATTACHMENT_TYPE_SOURCE,
  ATTACHMENT_TYPE_FOLLOW_UP,
  ATTACHMENT_TYPE_504_LINK,
  ATTACHMENT_TYPE_USER_INTERACTION
]

const ATTACHMENT_WIDTH = 28.75 // In spacing units.
const ATTACHMENT_HEIGHT = 19.75

// This serves as the “master copy” of an attachment object.
// Type-specific components will declare a subset of these.
const ATTACHMENT_SHAPE = {
  author_name: PropTypes.string,
  image_url: PropTypes.string,
  og_scrape_url: PropTypes.string,
  post: PropTypes.object, // TODO convert to shape
  text: PropTypes.string,
  thumb_url: PropTypes.string,
  title: PropTypes.string,
  title_link: PropTypes.string,
  type: PropTypes.string,
  interactionType: PropTypes.object, // For user interactions: the interaction’s spec, keyed by its kind.
  messageId: PropTypes.string // The id of the message the attachment belongs to, when known.
}

export {
  ATTACHMENT_TYPES,
  ATTACHMENT_TYPE_POST,
  ATTACHMENT_TYPE_EXTRACTION_LINK,
  ATTACHMENT_TYPE_AAM_EXTRACTION_LINK,
  ATTACHMENT_TYPE_IEP_LINK,
  ATTACHMENT_TYPE_IPP_LINK,
  ATTACHMENT_TYPE_504_LINK,
  ATTACHMENT_TYPE_FOLLOW_UP,
  ATTACHMENT_TYPE_SOURCE,
  ATTACHMENT_TYPE_USER_INTERACTION,
  ATTACHMENT_WIDTH,
  ATTACHMENT_HEIGHT,
  ATTACHMENT_SHAPE
}
